import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bddbd14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-between-box" }
const _hoisted_2 = { class: "step-left-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-title-box" }, "已注册微信小程序？授权发布", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-desc-box" }, " 使用微信小程序管理员帐号扫码进行授权，授权过程中请勾选所有权限以确保小程序功能完整性。如未注册小程序，点击下方注册（注册成功后自动绑定）。 ", -1))
const _hoisted_5 = { class: "step-right-box" }
const _hoisted_6 = { class: "step-between-box" }
const _hoisted_7 = { class: "step-left-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-title-box" }, "设置小程序支付方式", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-desc-box" }, " 微信支付商户ID ", -1))
const _hoisted_10 = { class: "step-right-box" }
const _hoisted_11 = { class: "step-between-box" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-left-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-title-box" }, " 完成所有准备，提交或查看体验版 "),
  /*#__PURE__*/_createElementVNode("div", { class: "step-desc-box" }, " 体验版可先提前查看效果，提交微信审核（最长14个工作日），审核通过后即可立即发布版本。 ")
], -1))
const _hoisted_13 = { class: "step-right-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_SuccessFilled = _resolveComponent("SuccessFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "container-box" }, {
    default: _withCtx(() => [
      _createVNode(_component_ui_card, null, {
        title: _withCtx(() => [
          _createVNode(_component_ui_title, { title: "微信授权" })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_steps, { direction: "vertical" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_step, { status: "finish" }, {
                  description: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _hoisted_4,
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_link, {
                            type: "primary",
                            onClick: _ctx.registerMiniCode
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.registerStatus
                        ? "查看注册状态"
                        : "没有注册小程序？立即注册"), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        (_ctx.store.appid)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "auth-icon-box",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoAuth && _ctx.gotoAuth(...args)))
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_SuccessFilled)
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" 重新授权 ")
                            ]))
                          : _withDirectives((_openBlock(), _createBlock(_component_ui_button, {
                              key: 1,
                              onClick: _ctx.gotoAuth,
                              disabled: _ctx.registerStatus && _ctx.registerStatus.status != 0
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("点击授权")
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"])), [
                              [_directive_loading, _ctx.authLoading]
                            ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_step, { status: "finish" }, {
                  description: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _hoisted_9,
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_link, {
                            type: "primary",
                            underline: false
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 没有支付请联系管理员")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.store.setPay)
                          ? (_openBlock(), _createBlock(_component_ui_button, {
                              key: 0,
                              onClick: _ctx.paySetting
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("修改支付信息")
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_ui_button, {
                              key: 1,
                              onClick: _ctx.paySetting
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("支付设置")
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_step, { status: "finish" }, {
                  description: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ui_button, {
                          disabled: !_ctx.store.appid,
                          onClick: _ctx.viewCode
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("体验版")
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"]),
                        _createVNode(_component_ui_button, {
                          onClick: _ctx.submitAuidt,
                          disabled: !_ctx.store.appid
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("提交审核")
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"]),
                        _createVNode(_component_ui_button, {
                          onClick: _ctx.withdrawAudit,
                          disabled: !_ctx.store.appid
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("撤回审核")
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"]),
                        _createVNode(_component_ui_button, {
                          onClick: _ctx.release,
                          disabled: !_ctx.store.appid
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("发布版本")
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}